import { useState } from 'react';

/**
 * The start of a rolling time window, anchored once per mount.
 *
 * `new Date(Date.now() - DAY_MS).toISOString()` in a component body produces a
 * different string on every render. A query key built from it therefore
 * changes on every render, so React Query starts a fresh query each time,
 * the fresh query resolves, that re-renders, and the key changes again. The
 * page loads forever and hammers the endpoint while it does.
 *
 * A `useState` initializer rather than `useMemo`: memo is a hint React may
 * discard, and this value must not move.
 */
export function useWindowStart(millisecondsAgo: number): string {
  const [start] = useState(() => new Date(Date.now() - millisecondsAgo).toISOString());
  return start;
}
